import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export const FaqAccordion = () => (
  <Accordion type="single" collapsible className="w-full">
    {FAQS.map((faq, i) => (
      <AccordionItem key={i} value={`faq-${i}`} className="border-b border-ink/10">
        <AccordionTrigger
          data-testid={`faq-question-${i}`}
          className="text-left font-display text-lg md:text-2xl text-ink hover:text-clinic py-6 hover:no-underline"
        >
          <span className="flex items-baseline gap-4">
            <span className="font-mono text-xs text-clinic shrink-0">
              {String(i + 1).padStart(2, "0")}
            </span>
            {faq.question}
          </span>
        </AccordionTrigger>
        <AccordionContent
          data-testid={`faq-answer-${i}`}
          className="text-base leading-relaxed text-ink/70 pl-10 pb-6 max-w-3xl"
        >
          {faq.answer}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
